/**
 * Différents motifs de dissolution d'un PACS
 */
const MOTIF_DISSOLUTION: Record<'key' | 'text' | 'value', number | string>[] = [
  {
    key: 0,
    text: '',
    value: 0,
  },
  {
    key: 1,
    text: 'Mariage des partenaires',
    value: 1,
  },
  {
    key: 2,
    text: 'Mariage du partenaire 1',
    value: 2,
  },
  {
    key: 3,
    text: 'Mariage du partenaire 2',
    value: 3,
  },
  {
    key: 4,
    text: 'Décès des partenaires',
    value: 4,
  },
  {
    key: 5,
    text: 'Décès du partenaire 1',
    value: 5,
  },
  {
    key: 6,
    text: 'Décès du partenaire 2',
    value: 6,
  },
  {
    key: 7,
    text: 'Décision unilatérale du partenaire 1',
    value: 7,
  },
  {
    key: 8,
    text: 'Décision unilatérale du partenaire 2',
    value: 8,
  },
  {
    key: 9,
    text: "Décision unilatérale du partenaire 1 à l'initiative d'un tuteur",
    value: 9,
  },
  {
    key: 10,
    text: "Décision unilatérale du partenaire 2 à l'initiative d'un tuteur",
    value: 10,
  },
  {
    key: 11,
    text: 'Déclaration conjointe des partenaires (commun accord)',
    value: 11,
  },
  {
    key: 12,
    text: "Déclaration conjointe des partenaires (commun accord) à l'initiative d'un tuteur",
    value: 12,
  },
];

export default MOTIF_DISSOLUTION;
